import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  () => ({
    migrationAlert: {
      color: '#BE1549',
      backgroundColor: '#BE15491A',
      borderRadius: '5px',
      padding: '16px',
      margin: '24px 32px'
    },
    migrationAlertContent: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    migrationAlertIcon: {
      marginRight: '8px',
      marginTop: '3px',
    },
    migrationAlertHeader: {
      '& .MuiTypography-root': {
        fontWeight: 600,
        fontSize: '13px',
      },
    },
    migrationAlertBody: {
      marginTop: '4px',
      '& .MuiTypography-root': {
        fontSize: '13px',
      },
    },
    migrationAlertCta: {
      display: 'flex',
      alignItems: 'center',
      margin: '25px 12px 4px 12px',
      color: '#000000',
      justifyContent: 'flex-end',
      textDecoration: 'none',
      '& .MuiTypography-root': {
        fontWeight: 600,
        fontSize: '13px',
        textDecoration: 'underline',
      },
    },
    balanceContainer: {
      paddingTop: '40px',
      paddingBottom: '32px',
    },
    balanceRow: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '32px',
    },
    balanceValue: {
      fontWeight: 600,
    },
    bankDetailsHeader: {
      paddingTop: '32px',
    },
    bankDetailsTitle: {
      paddingBottom: '5px',
    },
    bankDetailsTable: {
      paddingTop: '25px',
      paddingBottom: '25px',
    },
  }),
  { name: 'CurrencyAccountInfo' },
);

export default useStyles;
